module.exports = __webpack_public_path__ + "img/cas.f0047f0a.svg";